<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="菜单名称" prop="name">
      <a-input v-model="form.data.name"/>
    </a-form-model-item>
    <a-form-model-item label="编码" prop="code">
      <a-input
        v-model="form.data.code"/>
    </a-form-model-item>
    <a-form-model-item label="上层菜单" prop="parentId">
      <a-cascader
        change-on-select
        :props="{ checkStrictly: true }"
        v-model="form.data.parentId"
        :options="menu.tree"/>
    </a-form-model-item>
    <a-form-model-item label="类别" prop="type">
      <a-radio-group v-model="form.data.type">
        <a-radio  value="MENU">
          菜单
        </a-radio>
        <a-radio  value="BUTTON">
          按钮
        </a-radio>
      </a-radio-group>
    </a-form-model-item>
    <a-form-model-item
      label="菜单图标" prop="icon" v-if="form.data.type==='MENU'">
      <a-input v-model="form.data.icon"/>
    </a-form-model-item>
    <a-form-model-item
      label="前端路径" prop="path" v-if="form.data.type==='MENU'" property="path">
      <a-input
        v-model="form.data.path"/>
    </a-form-model-item>
    <a-form-model-item>
      <a-space>
        <a-button type="primary" v-if="!menuId" @click="onAdd">{{ $t('CREATE') || '创建' }}</a-button>
        <a-button type="primary" v-if="menuId" @click="onUpdate">{{ $t('UPDATE') || '创建' }}</a-button>
        <a-button @click="onCancel">取消</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import {
  _addMenu,
  _queryMenu,
  _queryMenus,
  _updateMenu,
} from '@/api/sys/sysMenuApi';

function treeGenerator(x, data, ignoreId) {
  const children = data
    .filter(child => child.value !== ignoreId && child.parentId === x.value)
    .map(child => treeGenerator(child, data));
  return {
    ...x,
    children,
  };
}

function getTreeNodeParent(x, data) {
  if (!x) {
    return [];
  }
  const parent = data.filter(child => child.value === x);
  if (parent[0]) {
    return [...getTreeNodeParent(parent[0].parentId, data), x];
  }
  return [x];
}

async function getMenus() {
  const result = await _queryMenus({});
  if (result) {
    const menus = result.filter(x => x.type === 'MENU').map(x => ({
      value: x.id,
      label: x.name,
      parentId: x.parentId,
    }));
    this.menu.data = menus;
    this.menu.tree = [
      {
        value: null,
        label: '根节点',
        children: menus
          .filter(x => !x.parentId && x.value !== this.menuId)
          .map(x => treeGenerator(x, menus, this.menuId)),
      },
    ];
  }
}

async function getMenu() {
  const result = await _queryMenu(this.menuId);
  if (result) {
    this.form.data.name = result.name;
    this.form.data.icon = result.icon;
    this.form.data.path = result.path;
    this.form.data.type = result.type;
    this.form.data.code = result.code;
    this.form.data.parentId = [null, ...getTreeNodeParent(
      result.parentId,
      this.menu.data,
    )];
  }
}

async function onAdd() {
  this.form.disabled = true;
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addMenu({
        name: this.form.data.name,
        icon: this.form.data.icon,
        code: this.form.data.code,
        path: this.form.data.path,
        type: this.form.data.type,
        parentId: this.form.data.parentId.length > 0
          ? this.form.data.parentId[this.form.data.parentId.length - 1] : null,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success(this.$t('ADD_SUCCESS'));
          this.onSubmitHandler();
        }
      }
    } else {
      this.form.disabled = false;
    }
  });
}

async function onUpdate() {
  this.form.disabled = true;
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateMenu(this.menuId, {
        name: this.form.data.name,
        icon: this.form.data.icon,
        code: this.form.data.code,
        path: this.form.data.path,
        type: this.form.data.type,
        parentId: this.form.data.parentId.length > 0
          ? this.form.data.parentId[this.form.data.parentId.length - 1] : null,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success(this.$t('UPDATE_SUCCESS'));
          if (this.onSubmitHandler) {
            this.onSubmitHandler();
          }
        }
      }
    } else {
      this.form.disabled = false;
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'MenuEdit',
  props: {
    menuId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    menuId(val) {
      this.form.data = {
        name: '',
        parentId: [null],
        icon: '',
        path: '',
        type: 'MENU',
      };
      this.getMenus();
      if (val) {
        this.getMenu();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getMenu,
    getMenus,
  },
  data() {
    return {
      menu: {
        data: [],
        tree: [],
      },
      form: {
        data: {
          name: '',
          type: 'MENU',
          icon: '',
          code: '',
          path: '',
          parentId: [null],
        },
        rules: {
          name: [{ required: true, message: '请输入菜单名称', trigger: 'blur' }],
          parentId: [{ required: false, message: 'please choose parentId', trigger: 'blur' }],
          icon: [{ required: false, message: 'please input icon', trigger: 'blur' }],
          code: [{ required: false, message: 'please input code', trigger: 'blur' }],
          path: [{ required: false, message: 'please input path', trigger: 'blur' }],
        },
        disabled: false,
        title: '',
      },
    };
  },
  created() {
    this.getMenus();
    if (this.menuId) {
      this.getMenu();
    }
  },
};
</script>
